module.exports = {
  env: 'production',
  apiUrl: '',
  authConfig: {}
}
